/**
 * Module-level tracker for in-flight saves of user attendees.
 *
 * The cart checkout flow auto-saves a "new attendee" when a ticket card
 * collapses. The next ticket card's SavedAttendeePicker may try to reload
 * the saved attendees list before that auto-save has finished. This shared
 * tracker lets the picker wait for any pending saves so freshly saved
 * attendees show up immediately.
 */

const pending = new Set<Promise<unknown>>()

export function useUserAttendeeSaves() {
  const trackAttendeeSave = <T>(promise: Promise<T>): Promise<T> => {
    pending.add(promise)
    promise.finally(() => {
      pending.delete(promise)
    })

    return promise
  }

  const flushAttendeeSaves = async (): Promise<void> => {
    if (pending.size === 0)
      return

    await Promise.allSettled(Array.from(pending))
  }

  return {
    trackAttendeeSave,
    flushAttendeeSaves,
  }
}
